// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   IconButton,
//   MenuItem,
//   Autocomplete,
// } from '@mui/material';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
// import CloseIcon from '@mui/icons-material/Close';
// import dayjs from 'dayjs';
// import { useSelector } from 'react-redux';
// import { getGoogleLocalPlaces } from '../../../../Redux/helpers/JobsApi';
// import { getPersonalEvents, postPersonalEvents, updatePersonalEvents } from '../../../../Redux/Reducers/calendarReducer';
// import { useDispatch } from 'react-redux';
// import TimePicker from '../../../../Components/Utilities/TimePicker';


// const SchedulePersonalEvent = ({ open, onClose, selectedEvent, selectedDate, isPastDate }) => {
//   const dispatch = useDispatch();
  
//   const getInitialTime = () => {
//     const now = dayjs();
//     if (dayjs(selectedDate).isSame(now, 'day')) {
//       return now.minute() > 30 ? now.add(1, 'hour').startOf('hour') : now.startOf('hour');
//     }
//     return dayjs(selectedDate).hour(9).startOf('hour');
//   };

//   const [formData, setFormData] = useState({
//     title: '',
//     description: '',
//     eventDate: selectedDate || dayjs(),
//     startTime: getInitialTime(),
//     endTime: getInitialTime().add(1, 'hour'),
//     meetingType: 'Others',
//     attendees: [],
//     location: '',
//     timeZone: 'Asia/Kolkata',
//     meetLink: ''
//   });
  
//   const Connectedcontact = useSelector((state) => state?.ContactArray?.ConnectedContact);
//   const [timeError, setTimeError] = useState(null);
//   const [locations, setLocations] = useState([]);
//   console.log("Connectedcontact", Connectedcontact)
//   useEffect(() => {
//     if (selectedEvent) {
//       setFormData({
//         id: selectedEvent?.id || '',
//         title: selectedEvent?.title || '',
//         description: selectedEvent?.description || '',
//         eventDate: selectedEvent?.startTime ? dayjs(selectedEvent.startTime) : dayjs(selectedDate),
//         startTime: selectedEvent?.startTime ? dayjs(selectedEvent.startTime) : getInitialTime(),
//         endTime: selectedEvent?.endTime ? dayjs(selectedEvent.endTime) : getInitialTime().add(1, 'hour'),
//         meetingType: selectedEvent?.eventType === 'Interview' ? 'Remote' : (selectedEvent?.location === 'Remote' ? 'Remote' : 'Others'),
//         attendees: selectedEvent?.attendees || [],
//         location: selectedEvent?.location || '',
//         timeZone: selectedEvent?.timeZone || 'Asia/Kolkata',
//         meetLink: selectedEvent?.meetLink || ''
//       });
//     } else {
//       setFormData({
//         id: '',
//         title: '',
//         description: '',
//         eventDate: dayjs(selectedDate),
//         startTime: getInitialTime(),
//         endTime: getInitialTime().add(1, 'hour'),
//         meetingType: 'Others',
//         attendees: [],
//         location: '',
//         meetLink: '',
//         timeZone: 'Asia/Kolkata'
//       });
//     }
//   }, [selectedEvent, selectedDate]);

//   const handleSubmit = async(e) => {
//     e.preventDefault();
//     const now = dayjs();

//     if (!formData.startTime || !formData.endTime || !formData.eventDate) {
//       setTimeError('Please select date and both start and end times');
//       return;
//     }

//     // Combine the selected date with the selected times
//     const startDateTime = formData.eventDate
//       .hour(formData.startTime.hour())
//       .minute(formData.startTime.minute())
//       .second(0);

//     const endDateTime = formData.eventDate
//       .hour(formData.endTime.hour())
//       .minute(formData.endTime.minute())
//       .second(0);

//     // If end time is before start time on the same day, add 1 day to end date
//     let finalEndDateTime = endDateTime;
//     if (endDateTime.isBefore(startDateTime)) {
//       finalEndDateTime = endDateTime.add(1, 'day');
//     }

//     // Validation
//     if (startDateTime.isBefore(now)) {
//       setTimeError("Cannot schedule events in the past");
//       return;
//     }

//     if (finalEndDateTime.isBefore(startDateTime)) {
//       setTimeError("End time must be after start time");
//       return;
//     }

//     const payload = {
//       id: formData.id,
//       title: formData.title,
//       description: formData.description,
//       startTime: startDateTime.toISOString(),
//       endTime: finalEndDateTime.toISOString(),
//       eventType: formData.meetingType === 'Remote' ? 'Interview' : 'Personal',
//       meetingType: formData.meetingType,
//       attendees: formData.attendees.map(attendee => ({
//         name: attendee.name,
//         email: attendee.email,
//         profile_pic: attendee.profile_pic || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
//       })),
//       location: formData.meetingType === 'Remote' ? 'Remote' : formData.location,
//       meetLink: formData.meetLink,
//       timeZone: formData.timeZone
//     };

//     console.log('Submitting payload:', payload);
    
//     try {
//       if (formData.id) {
//         // Update existing event
//         const newPayload = {
//           ...payload,
//           type:
//             new Date(selectedEvent?.startTime)?.getTime() ===
//               new Date(payload?.startTime)?.getTime() &&
//             new Date(selectedEvent?.endTime)?.getTime() ===
//               new Date(payload?.endTime)?.getTime()
//               ? 'not_reschedule'
//               : 'reschedule',
//         };
//         await dispatch(updatePersonalEvents(newPayload));
//       } else {
//         // Create new event
//         await dispatch(postPersonalEvents(payload));
//       }
      
//       // Refresh events list
//       await dispatch(getPersonalEvents());
//       setFormData({
//         title: '',
//         description: '',
//         eventDate: dayjs(selectedDate),
//         startTime: getInitialTime(),
//         endTime: getInitialTime().add(1, 'hour'),
//         meetingType: 'Others',
//         attendees: [],
//         location: '',
//         timeZone: 'Asia/Kolkata',
//         meetLink: ''
//       });
//       onClose();
//     } catch (error) {
//       console.error('Failed to save event:', error);
//     }
//   };

//   const handleDateChange = (newDate) => {
//     if (!newDate) return;
    
//     const now = dayjs();
//     if (isPastDate && isPastDate(newDate)) {
//       setTimeError("Cannot select a past date");
//       return;
//     }
    
//     setFormData({
//       ...formData,
//       eventDate: newDate
//     });
//     setTimeError(null);
//   };

//   const handleStartTimeChange = (newTime) => {
//     if (!newTime) return;
    
//     setFormData({
//       ...formData,
//       startTime: newTime,
//       // If start time changes and is after end time on the same day, adjust end time
//       endTime: newTime.isAfter(formData.endTime) ? newTime.add(1, 'hour') : formData.endTime
//     });
//     setTimeError(null);
//   };

//   const handleEndTimeChange = (newTime) => {
//     if (!newTime) return;
    
//     // Allow end time to be before start time (for overnight events)
//     setFormData({
//       ...formData,
//       endTime: newTime
//     });
//     setTimeError(null);
//   };

//   const onChangeLocation = async (input) => {
//     try {
//       // Input validation
//       if (!input || typeof input !== 'string') {
//         setLocations([]);
//         return;
//       }
  
//       // Only fetch if input is longer than 2 characters
//       if (input.length > 2) {
//         // Show loading state
//         setLocations([]); 
  
//         const response = await getGoogleLocalPlaces(input);
        
//         // Handle different response formats
//         if (Array.isArray(response)) {
//           // Handle simple string array response
//           setLocations(response?.map(place => ({
//             description: place,
//             placeId: place
//           })));
//         } 
//         else if (response?.predictions) {
//           // Handle Google Places API response format
//           const validLocations = response.predictions
//             .filter(place => place?.description)
//             .map(place => ({
//               description: place.description,
//               placeId: place.place_id || place.description
//             }));
//           setLocations(validLocations);
//         } 
//         else {
//           console.error('Invalid response format:', response);
//           setLocations([]);
//         }
  
//         console.log(`Found ${locations.length} locations for query: ${input}`);
//       }
//     } catch (error) {
//       console.error('Error fetching locations:', error);
//       setLocations([]);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         position: 'fixed',
//         top: 0,
//         right: open ? 0 : '-400px',
//         width: '400px',
//         height: '100%',
//         backgroundColor: '#fff',
//         boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
//         transition: 'right 0.3s ease',
//         zIndex: 2200,
//         overflow: 'auto',
//       }}
//     >
//       <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             mb: 3,
//           }}
//         >
//           <Typography variant="h6">
//             {formData?.id ? 'Edit Event' : 'Schedule Event'}
//           </Typography>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </Box>

//         <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 3 }}>
//           <TextField
//             label="Event Title"
//             fullWidth
//             required
//             value={formData?.title}
//             onChange={(e) =>
//               setFormData({ ...formData, title: e.target.value })
//             }
//           />

//           <TextField
//             label="Description"
//             fullWidth
//             multiline
//             rows={3}
//             value={formData?.description}
//             onChange={(e) =>
//               setFormData({ ...formData, description: e.target.value })
//             }
//           />
          
//           <TextField
//             select
//             label="Meeting Type"
//             fullWidth
//             value={formData.meetingType}
//             onChange={(e) =>
//               setFormData({ ...formData, meetingType: e.target.value })
//             }
//           >
//             <MenuItem value="Remote">Online</MenuItem>
//             <MenuItem value="Others">Offline</MenuItem>
//           </TextField>

//           {formData.meetingType === 'Remote' ? (
//             <TextField
//               label="Meeting Link"
//               fullWidth
//               value={formData.meetLink}
//               onChange={(e) =>
//                 setFormData({ ...formData, meetLink: e.target.value })
//               }
//             />
//           ) : (
//             <Autocomplete
//               freeSolo
//               options={locations}
//               getOptionLabel={(option) => {
//                 if (!option) return '';
//                 return typeof option === 'string' ? option : option.description || ''
//               }}
//               value={formData?.location || null}
//               onChange={(event, newValue) => {
//                 setFormData({
//                   ...formData,
//                   location: typeof newValue === 'string' ? newValue : newValue?.description || ''
//                 });
//               }}
//               onInputChange={(event, newValue) => {
//                 if (event?.type === 'change') {
//                   onChangeLocation(newValue);
//                 }
//               }}
//               filterOptions={(options, params) => {
//                 const filtered = options.filter(option => {
//                   const value = typeof option === 'string' ? option : option.description;
//                   return value.toLowerCase().includes(params.inputValue.toLowerCase());
//                 });
//                 return filtered;
//               }}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label="Location"
//                   required
//                   variant="outlined"
//                   fullWidth
//                   InputProps={{
//                     ...params.InputProps,
//                     style: { fontSize: "0.875rem" },
//                   }}
//                 />
//               )}
//               renderOption={(props, option) => (
//                 <li {...props}>
//                   <Typography variant="body2">
//                     {typeof option === 'string' ? option : option.description}
//                   </Typography>
//                 </li>
//               )}
//               noOptionsText="No locations found"
//               loading={locations.length === 0}
//               loadingText="Searching locations..."
//             />
//           )}

//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <Box sx={{ mt: 2 }}>
//               {/* Single Date Picker */}
//               <DatePicker
//                 label="Event Date"
//                 value={formData.eventDate}
//                 onChange={handleDateChange}
//                 minDate={dayjs()}
//                 disabled={isPastDate && isPastDate(formData.eventDate)}
//                 slotProps={{
//                   textField: {
//                     fullWidth: true,
//                     sx: { mb: 2 }
//                   }
//                 }}
//               />
              
//               {/* Time Pickers in a row */}
//               <Box
//                 sx={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   gap: 2,
//                 }}
//               >
//                 {/* Start Time Picker */}
//                 <TimePicker
//                   label="Start Time"
//                   value={formData.startTime}
//                   onChange={handleStartTimeChange}
//                   error={!!timeError}
//                   helperText={timeError}
//                 />
                
//                 {/* End Time Picker */}
//                 <TimePicker
//                   label="End Time"
//                   value={formData.endTime}
//                   onChange={handleEndTimeChange}
//                   error={!!timeError}
//                   helperText={timeError}
//                 />
//               </Box>
//             </Box>
//           </LocalizationProvider>

//           {timeError && (
//             <Typography color="error" variant="body2" sx={{ mt: 1 }}>
//               {timeError}
//             </Typography>
//           )}

//           <Autocomplete
//             multiple
//             options={Connectedcontact || []}
//             getOptionLabel={(option) => 
//               `${option?.first_name} ${option?.last_name}${option?.email ? ` (${option?.email})` : ''}`
//             }
//             filterOptions={(options, { inputValue }) => {
//               const input = inputValue.toLowerCase();
//               return options.filter(option =>
//                 option.first_name?.toLowerCase().includes(input) ||
//                 option.last_name?.toLowerCase().includes(input) ||
//                 option.email?.toLowerCase().includes(input)
//               );
//             }}
//             value={Connectedcontact?.filter(contact => 
//               formData?.attendees?.some(attendee => attendee?.email === contact?.email)
//             )}
//             onChange={(_, newValue) => {
//               const attendees = newValue?.map(contact => ({
//                 name: [contact.first_name, contact.last_name].filter(Boolean).join(' '),
//                 email: contact?.email,
//                 profile_pic: contact?.profile_url || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
//               }));
//               setFormData({ ...formData, attendees });
//             }}
//             renderTags={() => null}
//             renderOption={(props, option) => (
//               <li {...props}>
//                 <img
//                   src={option.profile_url || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"}
//                   alt={`${option.first_name} ${option.last_name}`}
//                   style={{
//                     width: 32,
//                     height: 32,
//                     borderRadius: '50%',
//                     marginRight: 8,
//                     objectFit: 'cover'
//                   }}
//                 />
//                 <span>
//                   {option.first_name} {option.last_name}
//                 </span>
//               </li>
//             )}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Attendees"
//                 placeholder="Search by name or email"
//               />
//             )}
//           />
          
//           <Box sx={{ 
//             display: 'flex', 
//             flexWrap: 'wrap', 
//             gap: 1, 
//             maxHeight: 150, 
//             maxWidth:"100%",
//             overflowY: 'auto',
//             p: 1,
//             borderRadius: 1
//           }}>
//             {formData?.attendees?.map((attendee, index) => (
//               <Box 
//                 key={attendee.email || index}
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   p: 1,
//                   bgcolor: 'background.paper',
//                   borderRadius: 4,
//                   boxShadow: 1
//                 }}
//               >
//                 <img
//                   src={attendee.profile_pic || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"}
//                   alt={attendee.name}
//                   style={{
//                     width: 32,
//                     height: 32,
//                     borderRadius: '50%',
//                     objectFit: 'cover'
//                   }}
//                 />
//                 <Typography variant="body2">{attendee.name}</Typography>
//                 <IconButton 
//                   size="small" 
//                   onClick={() => {
//                     const newAttendees = [...formData.attendees];
//                     newAttendees.splice(index, 1);
//                     setFormData({ ...formData, attendees: newAttendees });
//                   }}
//                   sx={{ ml: 0.5 }}
//                 >
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             ))}
//           </Box>

//           <Button
//             type="submit"
//             variant="contained"
//             fullWidth
//             sx={{ mt: 2 }}
//           >
//             {formData?.id ? 'Update Event' : 'Create Event'}
//           </Button>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default SchedulePersonalEvent;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  MenuItem,
  Autocomplete,
  CircularProgress,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getGoogleLocalPlaces } from '../../../../Redux/helpers/JobsApi';
import { getPersonalEvents, postPersonalEvents, updatePersonalEvents } from '../../../../Redux/Reducers/calendarReducer';
import { useDispatch } from 'react-redux';
import TimePicker from '../../../../Components/Utilities/TimePicker';

const SchedulePersonalEvent = ({ open, onClose, selectedEvent, selectedDate, isPastDate }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false); // Add loading state
  
  const getInitialTime = () => {
    const now = dayjs();
    if (dayjs(selectedDate).isSame(now, 'day')) {
      return now.minute() > 30 ? now.add(1, 'hour').startOf('hour') : now.startOf('hour');
    }
    return dayjs(selectedDate).hour(9).startOf('hour');
  };

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    eventDate: selectedDate || dayjs(),
    startTime: getInitialTime(),
    endTime: getInitialTime().add(1, 'hour'),
    meetingType: 'Others',
    attendees: [],
    location: '',
    timeZone: 'Asia/Kolkata',
    meetLink: ''
  });
  
  const Connectedcontact = useSelector((state) => state?.ContactArray?.ConnectedContact);
  const [timeError, setTimeError] = useState(null);
  const [locations, setLocations] = useState([]);
  
  useEffect(() => {
    if (selectedEvent) {
      setFormData({
        id: selectedEvent?.id || '',
        title: selectedEvent?.title || '',
        description: selectedEvent?.description || '',
        eventDate: selectedEvent?.startTime ? dayjs(selectedEvent.startTime) : dayjs(selectedDate),
        startTime: selectedEvent?.startTime ? dayjs(selectedEvent.startTime) : getInitialTime(),
        endTime: selectedEvent?.endTime ? dayjs(selectedEvent.endTime) : getInitialTime().add(1, 'hour'),
        meetingType: selectedEvent?.eventType === 'Interview' ? 'Remote' : (selectedEvent?.location === 'Remote' ? 'Remote' : 'Others'),
        attendees: selectedEvent?.attendees || [],
        location: selectedEvent?.location || '',
        timeZone: selectedEvent?.timeZone || 'Asia/Kolkata',
        meetLink: selectedEvent?.meetLink || ''
      });
    } else {
      setFormData({
        id: '',
        title: '',
        description: '',
        eventDate: dayjs(selectedDate),
        startTime: getInitialTime(),
        endTime: getInitialTime().add(1, 'hour'),
        meetingType: 'Others',
        attendees: [],
        location: '',
        meetLink: '',
        timeZone: 'Asia/Kolkata'
      });
    }
  }, [selectedEvent, selectedDate]);

  const handleSubmit = async(e) => {
    e.preventDefault();
    
    // Prevent multiple submissions
    if (loading) return;
    
    const now = dayjs();

    if (!formData.startTime || !formData.endTime || !formData.eventDate) {
      setTimeError('Please select date and both start and end times');
      return;
    }

    // Combine the selected date with the selected times
    const startDateTime = formData.eventDate
      .hour(formData.startTime.hour())
      .minute(formData.startTime.minute())
      .second(0);

    const endDateTime = formData.eventDate
      .hour(formData.endTime.hour())
      .minute(formData.endTime.minute())
      .second(0);

    // If end time is before start time on the same day, add 1 day to end date
    let finalEndDateTime = endDateTime;
    if (endDateTime.isBefore(startDateTime)) {
      finalEndDateTime = endDateTime.add(1, 'day');
    }

    // Validation
    if (startDateTime.isBefore(now)) {
      setTimeError("Cannot schedule events in the past");
      return;
    }

    if (finalEndDateTime.isBefore(startDateTime)) {
      setTimeError("End time must be after start time");
      return;
    }

    // Set loading to true before API call
    setLoading(true);
    
    const payload = {
      id: formData.id,
      title: formData.title,
      description: formData.description,
      startTime: startDateTime.toISOString(),
      endTime: finalEndDateTime.toISOString(),
      eventType: formData.meetingType === 'Remote' ? 'Interview' : 'Personal',
      meetingType: formData.meetingType,
      attendees: formData.attendees.map(attendee => ({
        name: attendee.name,
        email: attendee.email,
        profile_pic: attendee.profile_pic || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
      })),
      location: formData.meetingType === 'Remote' ? 'Remote' : formData.location,
      meetLink: formData.meetLink,
      timeZone: formData.timeZone
    };
    
    try {
      if (formData.id) {
        // Update existing event
        const newPayload = {
          ...payload,
          type:
            new Date(selectedEvent?.startTime)?.getTime() ===
              new Date(payload?.startTime)?.getTime() &&
            new Date(selectedEvent?.endTime)?.getTime() ===
              new Date(payload?.endTime)?.getTime()
              ? 'not_reschedule'
              : 'reschedule',
        };
        await dispatch(updatePersonalEvents(newPayload));
      } else {
        // Create new event
        await dispatch(postPersonalEvents(payload));
      }
      
      // Refresh events list
      await dispatch(getPersonalEvents());
      setFormData({
        title: '',
        description: '',
        eventDate: dayjs(selectedDate),
        startTime: getInitialTime(),
        endTime: getInitialTime().add(1, 'hour'),
        meetingType: 'Others',
        attendees: [],
        location: '',
        timeZone: 'Asia/Kolkata',
        meetLink: ''
      });
      onClose();
    } catch (error) {
      console.error('Failed to save event:', error);
    } finally {
      // Always set loading to false when done
      setLoading(false);
    }
  };

  const handleDateChange = (newDate) => {
    if (!newDate) return;
    
    const now = dayjs();
    if (isPastDate && isPastDate(newDate)) {
      setTimeError("Cannot select a past date");
      return;
    }
    
    setFormData({
      ...formData,
      eventDate: newDate
    });
    setTimeError(null);
  };

  const handleStartTimeChange = (newTime) => {
    if (!newTime) return;
    
    setFormData({
      ...formData,
      startTime: newTime,
      // If start time changes and is after end time on the same day, adjust end time
      endTime: newTime.isAfter(formData.endTime) ? newTime.add(1, 'hour') : formData.endTime
    });
    setTimeError(null);
  };

  const handleEndTimeChange = (newTime) => {
    if (!newTime) return;
    
    // Allow end time to be before start time (for overnight events)
    setFormData({
      ...formData,
      endTime: newTime
    });
    setTimeError(null);
  };

  const onChangeLocation = async (input) => {
    try {
      // Input validation
      if (!input || typeof input !== 'string') {
        setLocations([]);
        return;
      }
  
      // Only fetch if input is longer than 2 characters
      if (input.length > 2) {
        // Show loading state
        setLocations([]); 
  
        const response = await getGoogleLocalPlaces(input);
        
        // Handle different response formats
        if (Array.isArray(response)) {
          // Handle simple string array response
          setLocations(response?.map(place => ({
            description: place,
            placeId: place
          })));
        } 
        else if (response?.predictions) {
          // Handle Google Places API response format
          const validLocations = response.predictions
            .filter(place => place?.description)
            .map(place => ({
              description: place.description,
              placeId: place.place_id || place.description
            }));
          setLocations(validLocations);
        } 
        else {
          console.error('Invalid response format:', response);
          setLocations([]);
        }
  
        console.log(`Found ${locations.length} locations for query: ${input}`);
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
      setLocations([]);
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        right: open ? 0 : '-400px',
        width: '400px',
        height: '100%',
        backgroundColor: '#fff',
        boxShadow: '-2px 0 10px rgba(0,0,0,0.1)',
        transition: 'right 0.3s ease',
        zIndex: 2200,
        overflow: 'auto',
      }}
    >
      <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <Typography variant="h6">
            {formData?.id ? 'Edit Event' : 'Schedule Event'}
          </Typography>
          <IconButton onClick={onClose} disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'grid', gap: 3 }}>
          <TextField
            label="Event Title"
            fullWidth
            required
            value={formData?.title}
            onChange={(e) =>
              setFormData({ ...formData, title: e.target.value })
            }
            disabled={loading}
          />

          <TextField
            label="Description"
            fullWidth
            multiline
            rows={3}
            value={formData?.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
            disabled={loading}
          />
          
          {/* Meeting Type Select with MenuProps for z-index */}
          <TextField
            select
            label="Meeting Type"
            fullWidth
            value={formData.meetingType}
            onChange={(e) =>
              setFormData({ ...formData, meetingType: e.target.value })
            }
            disabled={loading}
            SelectProps={{
              MenuProps: {
                sx: { 
                  zIndex: 2400,
                },
                container: document.body,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              }
            }}
          >
            <MenuItem value="Remote">Online</MenuItem>
            <MenuItem value="Others">Offline</MenuItem>
          </TextField>

          {formData.meetingType === 'Remote' ? (
            <TextField
              label="Meeting Link"
              fullWidth
              value={formData.meetLink}
              onChange={(e) =>
                setFormData({ ...formData, meetLink: e.target.value })
              }
              disabled={loading}
            />
          ) : (
            <Autocomplete
              freeSolo
              options={locations}
              getOptionLabel={(option) => {
                if (!option) return '';
                return typeof option === 'string' ? option : option.description || ''
              }}
              value={formData?.location || null}
              onChange={(event, newValue) => {
                setFormData({
                  ...formData,
                  location: typeof newValue === 'string' ? newValue : newValue?.description || ''
                });
              }}
              onInputChange={(event, newValue) => {
                if (event?.type === 'change') {
                  onChangeLocation(newValue);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = options.filter(option => {
                  const value = typeof option === 'string' ? option : option.description;
                  return value.toLowerCase().includes(params.inputValue.toLowerCase());
                });
                return filtered;
              }}
              disabled={loading}
              // Popper props for z-index
              componentsProps={{
                popper: {
                  sx: { 
                    zIndex: 2400,
                  },
                  container: document.body,
                  style: { zIndex: 2400 },
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      enabled: true,
                      options: {
                        boundary: 'window',
                      },
                    },
                  ],
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location"
                  required
                  variant="outlined"
                  fullWidth
                  disabled={loading}
                  InputProps={{
                    ...params.InputProps,
                    style: { fontSize: "0.875rem" },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  <Typography variant="body2">
                    {typeof option === 'string' ? option : option.description}
                  </Typography>
                </li>
              )}
              noOptionsText="No locations found"
              loading={locations.length === 0}
              loadingText="Searching locations..."
            />
          )}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ mt: 2 }}>
              {/* Date Picker with Popper props */}
              <DatePicker
                label="Event Date"
                value={formData.eventDate}
                onChange={handleDateChange}
                minDate={dayjs()}
                disabled={loading || (isPastDate && isPastDate(formData.eventDate))}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    sx: { mb: 2 }
                  },
                  popper: {
                    sx: { 
                      zIndex: 2400,
                    },
                    container: document.body,
                    modifiers: [
                      {
                        name: 'preventOverflow',
                        enabled: true,
                        options: {
                          boundary: 'window',
                        },
                      },
                    ],
                  }
                }}
              />
              
              {/* Time Pickers in a row */}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 2,
                }}
              >
                {/* Start Time Picker */}
                <TimePicker
                  label="Start Time"
                  value={formData.startTime}
                  onChange={handleStartTimeChange}
                  error={!!timeError}
                  helperText={timeError}
                  disabled={loading}
                  // Add PopperProps if TimePicker supports it
                  componentsProps={{
                    popper: {
                      sx: { zIndex: 2400 },
                      container: document.body,
                    }
                  }}
                />
                
                {/* End Time Picker */}
                <TimePicker
                  label="End Time"
                  value={formData.endTime}
                  onChange={handleEndTimeChange}
                  error={!!timeError}
                  helperText={timeError}
                  disabled={loading}
                  // Add PopperProps if TimePicker supports it
                  componentsProps={{
                    popper: {
                      sx: { zIndex: 2400 },
                      container: document.body,
                    }
                  }}
                />
              </Box>
            </Box>
          </LocalizationProvider>

          {timeError && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {timeError}
            </Typography>
          )}

          {/* Attendees Autocomplete with Popper props */}
          <Autocomplete
            multiple
            options={(Connectedcontact || []).filter(contact => contact?.is_verified === 1)}
            getOptionLabel={(option) => 
              `${option?.first_name} ${option?.last_name}${option?.email ? ` (${option?.email})` : ''}`
            }
            filterOptions={(options, { inputValue }) => {
              const input = inputValue.toLowerCase();
              return options.filter(option =>
                option.first_name?.toLowerCase().includes(input) ||
                option.last_name?.toLowerCase().includes(input) ||
                option.email?.toLowerCase().includes(input)
              );
            }}
            value={(Connectedcontact || []).filter(contact => 
              contact?.is_verified === 1 &&
              formData?.attendees?.some(attendee => attendee?.email === contact?.email)
            )}
            onChange={(_, newValue) => {
              const attendees = newValue?.map(contact => ({
                name: [contact.first_name, contact.last_name].filter(Boolean).join(' '),
                email: contact?.email,
                is_verified: contact?.is_verified,
                profile_pic: contact?.profile_url || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"
              }));
              setFormData({ ...formData, attendees });
            }}
            disabled={loading}
            // Popper props for z-index
            componentsProps={{
              popper: {
                sx: { 
                  zIndex: 2400,
                },
                container: document.body,
                style: { zIndex: 2400 },
                modifiers: [
                  {
                    name: 'preventOverflow',
                    enabled: true,
                    options: {
                      boundary: 'window',
                    },
                  },
                ],
              }
            }}
            renderTags={() => null}
            renderOption={(props, option) => (
              <li {...props}>
                <Box sx={{ position: 'relative', mr: 1, flexShrink: 0 }}>
                  <img
                    src={option.profile_url || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"}
                    alt={`${option.first_name} ${option.last_name}`}
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid #4caf50',
                      display: 'block'
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: -2,
                      right: -2,
                      width: 13,
                      height: 13,
                      borderRadius: '50%',
                      bgcolor: '#4caf50',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '1.5px solid #fff',
                    }}
                  >
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                      <path d="M1.5 4L3 5.5L6.5 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </Box>
                </Box>
                <span>
                  {option.first_name} {option.last_name}
                </span>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Attendees"
                placeholder="Search by name or email"
                disabled={loading}
              />
            )}
          />
          
          {/* Selected attendees display */}
          <Box sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 1, 
            maxHeight: 150, 
            maxWidth:"100%",
            overflowY: 'auto',
            p: 1,
            borderRadius: 1
          }}>
            {formData?.attendees?.map((attendee, index) => (
              <Box 
                key={attendee.email || index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  p: 1,
                  bgcolor: 'background.paper',
                  borderRadius: 4,
                  boxShadow: 1
                }}
              >
                <Box sx={{ position: 'relative', flexShrink: 0 }}>
                  <img
                    src={attendee.profile_pic || "https://www.shutterstock.com/image-vector/default-avatar-profile-icon-transparent-600nw-2463868853.jpg"}
                    alt={attendee.name}
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: attendee.is_verified === 1 ? '2px solid #4caf50' : '2px solid transparent',
                      display: 'block'
                    }}
                  />
                  {attendee.is_verified === 1 && (
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: -2,
                        right: -2,
                        width: 13,
                        height: 13,
                        borderRadius: '50%',
                        bgcolor: '#4caf50',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1.5px solid #fff',
                      }}
                    >
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path d="M1.5 4L3 5.5L6.5 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </Box>
                  )}
                </Box>
                <Typography variant="body2">{attendee.name}</Typography>
                <IconButton 
                  size="small" 
                  onClick={() => {
                    const newAttendees = [...formData.attendees];
                    newAttendees.splice(index, 1);
                    setFormData({ ...formData, attendees: newAttendees });
                  }}
                  sx={{ ml: 0.5 }}
                  disabled={loading}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              formData?.id ? 'Update Event' : 'Create Event'
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default SchedulePersonalEvent;